import posthog from "posthog-js";

const API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;

export const initPosthog = (): void => {
  const key = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

  if (!key || !host) {
    console.log("PostHog not initialized (no API key or host found)");
    return;
  }

  posthog.init(key, {
    api_host: host,
    loaded: function (posthog) {
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        posthog.opt_out_capturing();
      }
    },
    defaults: "2025-05-24",
    capture_pageview: false,
    capture_performance: false,
    autocapture: false,
    capture_pageleave: false,
  });
};

export const logEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  posthog.capture(eventName, properties);
};

export const setUserAndProps = (
  userId: string,
  props?: Record<string, any>
) => {
  posthog.identify(userId, props);
};

export const resetPosthog = () => {
  posthog.reset();
};